/**
 * Tipos de notificação alinhados ao backend (NotificationResponseDto, enums).
 * Usado apenas para admin/profissional/atendente (cliente é notificado por WhatsApp).
 */

export enum NotificationStatusEnum {
  UNREAD = 'unread',
  READ = 'read',
}

export enum NotificationTypeEnum {
  PROFESSIONAL_CANCELLED = 'professional_cancelled',
  PROFESSIONAL_CANCELLED_ADMIN = 'professional_cancelled_admin',
  APPOINTMENT_CANCELLED = 'appointment_cancelled',
  APPOINTMENT_CANCELLED_ADMIN = 'appointment_cancelled_admin',
  WORK_CANCELLED = 'work_cancelled',
  WORK_CANCELLED_ADMIN = 'work_cancelled_admin',
}

export interface Notification {
  id: string;
  title: string;
  message: string;
  type: NotificationTypeEnum;
  status: NotificationStatusEnum;
  userId: string;
  createdAt: string;
  readAt?: string | null;
  updatedAt?: string | null;
}
